// extracted by mini-css-extract-plugin
export var consist = "consist-module--consist--a40f1";
export var container = "consist-module--container--482ca";
export var info = "consist-module--info--e8bef";